import { Route } from 'react-router-dom';

import BasicBoardPage from './BasicBoardPage';
import CardDebugPage from './CardDebugPage';
import PrintCardsPage from './PrintCardsPage';
import ReferenceDebugPage from './ReferenceDebugPage';
import SymbolDebugPage from './SymbolDebugPage';
import TributeDebugPage from './TributeDebugPage';
import TributeLayoutDebugPage from './TributeLayoutDebugPage';

export default function LocalRoutes() {
  if (process.env.NODE_ENV === 'development') {
    return (
      <>
        <Route path="debug_card" element={<CardDebugPage />} />
        <Route path="debug_tribute" element={<TributeDebugPage />} />
        <Route
          path="debug_tribute_layout"
          element={<TributeLayoutDebugPage />}
        />
        <Route path="debug_symbols" element={<SymbolDebugPage />} />
        <Route path="debug_reference" element={<ReferenceDebugPage />} />
        <Route path="debug_basic_board" element={<BasicBoardPage />} />
        <Route path="print" element={<PrintCardsPage />} />
      </>
    );
  }

  return null;
}
